import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "streamline-procurement-processes"
    }}>{`Streamline procurement processes`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Procurement departments have many document types that need to be shared with suppliers as PDFs. These include Purchase Orders, Requests for Proposal, Requests for Quote, and different agreement types. Creating, processing, and reviewing documents can be very time consuming.`}</p>
    <p>{`With Adobe Acrobat Services, companies save time by automating the following steps:`}</p>
    <ul>
      <li parentName="ul">{`Generate POs, RFPs, RFQs, or agreement documents in PDF from data in procurement management systems using Document Generation API`}</li>
      <li parentName="ul">{`Combine, secure from editing, and view documents before sharing with suppliers using PDF Services API`}</li>
      <li parentName="ul">{`View PDFs in procurement system for review using PDF Embed API`}</li>
      <li parentName="ul">{`Send agreements for signature using Adobe Acrobat Sign API`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A procurement team needs to send signed purchase orders frequently to suppliers, and they track all information about suppliers and processes in their procurement system. Currently, sending a PO involves manually copying information from the system to a Microsoft Word document, converting to PDF, uploading for internal review, manually sending for signature, and then sharing with the supplier. Fully automating this process would give team members time back.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this solution`}</h3>
    <p>{`Follow the steps below to automate PDF generation to streamline procurement processes:`}</p>
    <ol>
      <li parentName="ol">{`Identify the JSON data model used to export data from the procurement system`}</li>
      <li parentName="ol">{`Tag a Purchase Order template (Word) by uploading the JSON model to the Adobe Document Generation Tagger Microsoft Word add-in, and adding tags where data should be filled automatically`}</li>
      <li parentName="ol">{`Insert Adobe Acrobat Sign text tags in the PO template to make it ready to be used by Adobe Acrobat Sign`}</li>
      <li parentName="ol">{`Use Adobe Document Generation API to automatically merge procurement system data and the Word template to generate a PDF`}</li>
      <li parentName="ol">{`Use PDF Services API to combine PO with additional documents`}</li>
      <li parentName="ol">{`Adobe PDF Embed API embeds the PDF in the application for review and approval`}</li>
      <li parentName="ol">{`Use Adobe Acrobat Sign API to send the document out for signature once approved`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      